export default "__VITE_ASSET__da6d08a0__"